
















import {MyStudyChoiceOnboardingModelState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import {useActions, useGetters} from "vuex-composition-helpers"
import {ActionTree, GetterTree} from "vuex"
import {defineComponent} from "@vue/composition-api"

export default defineComponent({
    name: "HeaderNavigation",
    setup: () => {
        const {
            getSteps,
            getLabels,
            getActiveStepIndex
        } = useGetters<GetterTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'getSteps', 'getLabels', 'getActiveStepIndex'
        ]);
        const {setNavigateToStep} = useActions<ActionTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'setNavigateToStep'
        ]);

        function stepTitle(title: string) {
            return getLabels.value[title.toLowerCase()]
        }

        return {
            setNavigateToStep,
            getActiveStepIndex,
            stepTitle,
            getLabels,
            getSteps,
        }
    }
})
